import type { AnnounceImage as GQLType } from '../generated/checkout.graphql';
import * as AnnounceImageVariant from './AnnounceImageVariant';
import { take } from '../util/takePayload';

export type AnnounceImage = {
  name: string;
  highlighted?: boolean;
  variants?: AnnounceImageVariant.AnnounceImageVariant[];
};

export const fromGql = (gqlItem: GQLType): AnnounceImage => ({
  ...(take(gqlItem, 'name', 'highlighted') as AnnounceImage),
  variants: AnnounceImageVariant.fromGqlCollection(gqlItem.variants),
});
export const fromGqlCollection = (gqlItems?: GQLType[] | null) => (gqlItems ? gqlItems.map(fromGql) : []);
